<template>
  <div class="wrapper">
    <div class="width-medium mx-auto">
      <h1 class="heading-big my-3">{{ $t('opinion.yourOpinion') }}</h1>
      <template v-if="$store.getters.getUserHasFeature('comments')">
        <opinions-list />
      </template>
      <template v-else>
        <f-alert
          visible
          class="my-2"
          theme="inactive">
          <span>
          {{ $t('user.currentPackageDoesNotIncludeAccessToSection') }}
          </span>
        </f-alert>
      </template>
    </div>
  </div>
</template>

<script>
import OpinionsList from '@/views/lists/OpinionsList.vue';

export default {
  name: 'opinions',
  components: {
    'opinions-list': OpinionsList
  }
};
</script>
